webpackJsonp([14,18],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _generateBasicCardBlock = __webpack_require__(44);

var _generateBasicCardBlock2 = _interopRequireDefault(_generateBasicCardBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateLinkCard = function generateLinkCard(linkId, title, date, imageUrl) {
	var template = (0, _generateBasicCardBlock2.default)(title, date, imageUrl);

	template.setAttribute('href', 'media/' + linkId);

	return template;
};

exports.default = generateLinkCard;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var mediaList = function mediaList() {
	var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _appConfig.ARTICLE_NUMBER_PER_PAGE;
	return fetch(_appConfig.apiUri + '/report?from=' + from + '&take=' + count).then(function (res) {
		return res.json();
	}).catch(function (err) {
		return console.error(err);
	});
};

exports.default = mediaList;

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(8);

__webpack_require__(54);

__webpack_require__(43);

__webpack_require__(25);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _appConfig = __webpack_require__(2);

var _languageBasedTag = __webpack_require__(24);

var _languageBasedTag2 = _interopRequireDefault(_languageBasedTag);

var _mediaList = __webpack_require__(106);

var _mediaList2 = _interopRequireDefault(_mediaList);

var _generateLinkCard = __webpack_require__(101);

var _generateLinkCard2 = _interopRequireDefault(_generateLinkCard);

var _itemStartFrom = __webpack_require__(61);

var _itemStartFrom2 = _interopRequireDefault(_itemStartFrom);

var _pagination = __webpack_require__(62);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

document.head.appendChild((0, _languageBasedTag2.default)());

(0, _mediaList2.default)((0, _itemStartFrom2.default)(_pagination.currentPage, _appConfig.ARTICLE_NUMBER_PER_PAGE)).then(function (json) {
	json.reports.forEach(function (item) {
		document.querySelector('.section-block > .content').appendChild((0, _generateLinkCard2.default)(item.id, item.title, item.date, _appConfig.uploadUri + '/' + item.thumb));
	});
	(0, _pagination.addPaginationButtons)(json.total, _appConfig.ARTICLE_NUMBER_PER_PAGE);
}).then(function () {
	(0, _hideLoadingImage2.default)();
}).catch(function (err) {
	return console.error(err);
});

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlParser = __webpack_require__(9);

var _urlParser2 = _interopRequireDefault(_urlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * this function return a base tag which is base on language path
 *
 * You don't have to add the base tag in every page,
 * just use in the page url which has two or more path after the language, like: `/tw/about/video`.
 * If you are at `/tw/about`, you don't have to add this base tag.
 */
var LanguageBasedTag = function LanguageBasedTag() {
  var baseTag = document.createElement('base');
  baseTag.setAttribute('href', '/' + _urlParser2.default.language + '/');

  return baseTag;
};

exports.default = LanguageBasedTag;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var generateBasicCardBlock = function generateBasicCardBlock(title, date, imageUrl) {
	var template = document.querySelector('._template-block > .card-block').cloneNode(true);

	template.lastChild.lastChild.innerText = title;
	template.lastChild.firstChild.innerText = date;
	template.firstChild.setAttribute('style', 'background-image: url(' + imageUrl + ')');

	return template;
};

exports.default = generateBasicCardBlock;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(190);


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * tell you what the index number of the first data on this page is
 */
var itemStartFrom = function itemStartFrom(currentPage, numberInPage) {
	if (typeof currentPage !== 'number' || typeof numberInPage !== 'number') {
		return false;
	}

	if (currentPage === 1) {
		return 0;
	}

	return (currentPage - 1) * numberInPage;
};

exports.default = itemStartFrom;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var currentPage = exports.currentPage = window.location.search ? parseInt(window.location.search.split('=')[1], 10) : 1;

var addPaginationButtons = exports.addPaginationButtons = function addPaginationButtons(total, numberInPage) {
	if (total > numberInPage) {
		for (var i = 1; i < total / numberInPage + 1; i += 1) {
			var template = document.querySelector('._template-block > .page').cloneNode(true);
			template.href += '?page=' + i;
			template.innerHTML = i;
			template.className += '' + (i === currentPage ? ' -active' : '');
			document.querySelector('.tab-list').appendChild(template);
		}
	}
};

exports.default = 'this is pagination';

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[468]);


// WEBPACK FOOTER //
// media.f55776cadc9d4.js